<template>
    <div data-component="AmsTooltipModal">
        <div @click="onClick">
            <slot :isActive="isActive" />
        </div>
        <cs-tooltip-modal v-if="tooltip" v-model:visible="isActive" width="341px">
            <template #title>
                {{ tooltip.title }}
            </template>
            <span> {{ tooltip.text }} </span>

            <div v-if="tooltip.url" class="w-fit mt-15">
                <cs-secondary-button
                    class="self-start"
                    :href="tooltip.url"
                    target="_blank"
                    rel="noopener nofollow"
                    isSmall
                >
                    {{ tooltip.prefix }}
                    {{ tooltip.linkText }}
                </cs-secondary-button>
            </div>
        </cs-tooltip-modal>
    </div>
</template>
<script lang="ts" setup>
import { PropType, ref } from 'vue'
import { CsTooltipModal, CsSecondaryButton } from '@sunrise/components'
import { Tooltip } from './AmsTooltip.interface'

const isActive = ref(false)

const onClick = () => {
    isActive.value = true
}

defineProps({
    tooltip: {
        type: Object as PropType<Tooltip>,
        required: true,
    },
})
</script>
